require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-re-xl-y.json") })
        }
      }, "path---photos-professional-re-xl-y");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-re-xl-y!./.cache/json/photos-professional-re-xl-y.json
// module id = 887
// module chunks = 231608221292675